import { Link } from "react-router-dom";
import type { AnimeNews } from "@/types/anime";
import { formatViews } from "@/utils/anime";

const categoryColor: Record<string, string> = {
  TV动画: "bg-primary-100 text-primary-700",
  剧场版: "bg-accent-100 text-accent-800",
  漫画新闻: "bg-secondary-100 text-secondary-800",
};

export default function NewsCard({ news }: { news: AnimeNews }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
      <Link
        to={`/news/detail/${news.id}`}
        className="relative block h-44 w-full overflow-hidden bg-background-100 cursor-pointer"
      >
        <img
          src={news.cover}
          alt={`${news.title} 资讯配图`}
          title={`${news.title} - 78动漫资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium ${
            categoryColor[news.category] || "bg-secondary-100 text-secondary-800"
          }`}
        >
          {news.category}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line text-sm" />
            {news.dateLabel}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-sm" />
            {formatViews(news.views)}
          </span>
        </div>
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          <Link to={`/news/detail/${news.id}`} className="cursor-pointer">
            {news.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">{news.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {news.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-500">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}